import { getCourseByName as fetchCourseByName } from "../../mp-database"

export const getCourseByName = courseName => {
  return fetchCourseByName(courseName).then(querySnapshot => {
    let course = {}
    querySnapshot.forEach(doc => {
      let data = doc.data
      if (!data.deleted) {
        course = data
      }
    })
    return course
  })
}
